<template>
    <div>
        <div class="hover-item" ref="button" @mouseenter="show" @focus="show" @mouseleave="hide" @blur="hide">
            <LineBroadcastTag
              :tagText="displayRegisterGroupName(groupDetail.name, groupDetail.subGroups.length)"
              class="group-name-tag"
              />
        </div>
        <div class="tooltip-box" ref="tooltip" role="tooltip">
            <div id="arrow" data-popper-arrow></div>
            <div>
                <span class="tooltip-title">{{ groupDetail.name }}</span>
                <ul>
                    <li v-for="subGroup in groupDetail.subGroups" :key="subGroup.code">
                        <span class="tooltip-text">{{ subGroup.code }} {{ subGroup.name }}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { createPopper } from '@popperjs/core';
import LineBroadcastTag from '@/components/Tag/Broadcast/Line/LineBroadcastTag.vue';

export default {
  name: 'TargetGroupTagWithTooltip',
  components: {
    LineBroadcastTag
  },
  props: {
    groupDetail: {
      type: Object,
      required: true
    }
  },
  mounted() {
    const { button, tooltip } = this.$refs;
    this.popperInstance = createPopper(button, tooltip, {
      placement: 'right',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 8],
          },
        },
      ],
    });
  },
  methods: {
    show() {
      this.$refs.tooltip.setAttribute('data-show', '');
      this.popperInstance.setOptions((options) => ({
        ...options,
        modifiers: [
          ...options.modifiers,
          { name: 'eventListeners', enabled: true },
        ],
      }));
      this.popperInstance.update();
    },
    hide() {
      this.$refs.tooltip.removeAttribute('data-show');
      this.popperInstance.setOptions((options) => ({
        ...options,
        modifiers: [
          ...options.modifiers,
          { name: 'eventListeners', enabled: false },
        ],
      }));
    },
    displayRegisterGroupName(name, countSubGroup) {
      return `${name}(${countSubGroup})`;
    },
  },

};

</script>

<style lang="scss" scoped>
.group-name-tag{
    margin-top: 8px;
}
.tooltip-box {
    background: #111B49;
    color: white;
    font-weight: bold;
    padding: 12px;
    font-size: 13px;
    border-radius: 8px;
    position: relative;
    display: none;
    .tooltip-title {
        font-weight: 500;
        font-size: 12px;
        line-height: 150%;
        letter-spacing: 0px;
    }
    .tooltip-text {
        font-weight: 400;
        font-size: 12px;
        line-height: 150%;
        letter-spacing: 0px;
    }
    ul{
        padding-left: 24px;
        margin: 0;
    }
    #arrow,
    #arrow::before {
        position: absolute;
        width: 8px;
        height: 8px;
        background: inherit;
    }
    #arrow {
        visibility: hidden;
    }
    #arrow::before {
        visibility: visible;
        content: '';
        transform: rotate(45deg);
    }
}
.tooltip-box[data-show] {
  display: block;
}
.tooltip-box[data-popper-placement^='right'] > #arrow {
  left: -4px;
}
</style>
